import { IApp } from '@/types/nuxt'
import refresh from '@/utils/refresh'

export default class GetMeUseCase implements BaseUseCase {
  constructor(protected App: IApp) {}

  async execute() {
    try {
      await refresh(this.App)
      const me = await this.App.monitaroGateway.Auth.GetMe()
      this.App.user.current = me
      // Sentry のイベントをユーザー ID で特定できるようにする（氏名・メール等の個人情報は送らない）。
      // id が取れない場合は前ユーザーの情報が残らないようクリアする。
      if (me.id) {
        this.App.sentry.setUser({ id: me.id })
      } else {
        this.App.sentry.setUser(null)
      }
      return true
    } catch (exception: any) {
      // GetMe 失敗時は前ユーザーの情報が残らないよう Sentry の user をクリアする。
      this.App.sentry.setUser(null)
      this.App.logService.handle(exception)
    }
    return false
  }
}
